import { useTranslation } from "react-i18next";
import { PageTitle, PAgeTitle } from "../../widgets/small-widgets";

export default function UsersPage() {
    const { t } = useTranslation();

    return <div style={{padding: '1.2rem'}}>
        <PageTitle>{t('navigation.users')}</PageTitle>
    </div>;
}